module.exports = __webpack_public_path__ + "static/media/Anshul Kulkarni.263a8f55.jpg";